import React from 'react';
import ReactDOM from 'react-dom/client';
import * as Sentry from "@sentry/react";
import * as msal from "@azure/msal-browser";
import {
    BrowserRouter as Router,
} from 'react-router-dom';
import './css/theme.css';
import './css/fonts.css';
import './css/index.css';
import './css/sentry.css';
import 'react-toggle/style.css';
import { App } from './App';
import reportWebVitals from './reportWebVitals';
import { MsalProvider } from '@azure/msal-react';
import { msalConfig } from './authConfig';
import { Alert } from './utils/alert';

Sentry.init({
    dsn: "https://7c7bea8fcf4346b40c72336d5658cd91@o4510737881759744.ingest.us.sentry.io/4510834431557632",
    // Setting this option to true will send default PII data to Sentry.
    // For example, automatic IP address collection on events
    sendDefaultPii: true,
    integrations: [
        Sentry.replayIntegration({
            maskAllText: false,
            blockAllMedia: false,
        }),
        Sentry.feedbackIntegration({
            colorScheme: 'light',
            showBranding: false,
        }),
    ],
    // Session Replay
    replaysSessionSampleRate: 1.0, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0 // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});


if ('serviceWorker' in navigator) {
    navigator.serviceWorker.register(window.location.origin + '/serviceWorker.js')
        .then(function (registration) {
            // Registration was successful
            console.log('ServiceWorker registration successful with scope: ', registration.scope);
        }).catch(function (err) {
            // registration failed :(
            console.log('ServiceWorker registration failed: ', err);
        });
}

Alert.init();

// Apple requires interaction before sound can be played. This captures the context
document.addEventListener('click', Alert.unlock, { once: true });
document.addEventListener('touchstart', Alert.unlock, { once: true });

const msalInstance = new msal.PublicClientApplication(msalConfig);

ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
).render(
    // This really messes up data fetching...
    // <React.StrictMode>
    <MsalProvider instance={msalInstance}>
        <Router>
            <App />
        </Router>
    </MsalProvider>
    // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
